import type { SVGProps } from "react";

/**
 * A sun and a moon, for the light and dark switch. The design system's icon set has neither, so
 * they are drawn here in its outline style: a 24-unit box, round 1.5 strokes in currentColor.
 */
type Props = SVGProps<SVGSVGElement> & { size?: number };

function Outline({ size = 24, children, ...rest }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function SunIcon(props: Props) {
  return (
    <Outline {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.75v1.5M12 19.75v1.5M2.75 12h1.5M19.75 12h1.5M5.46 5.46l1.06 1.06M17.48 17.48l1.06 1.06M5.46 18.54l1.06-1.06M17.48 6.52l1.06-1.06" />
    </Outline>
  );
}

export function MoonIcon(props: Props) {
  return (
    <Outline {...props}>
      <path d="M20.25 14.4A8.25 8.25 0 0 1 9.6 3.75a8.25 8.25 0 1 0 10.65 10.65Z" />
    </Outline>
  );
}
